// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class CreateAlertMessage extends PFixMessage {
    get isAllowOTHTrading() {
        return this.getFieldValue(FieldsFactory.FIELD_ALLOW_OTH_TRADING);
    }
    set isAllowOTHTrading(value) {
        if (!isNullOrUndefined(value)) {
            this.setFieldValue(FieldsFactory.FIELD_ALLOW_OTH_TRADING, value);
        }
    }
    constructor(fieldSet) {
        super(Message.CODE_CREATE_ALERT_MESSAGE, fieldSet);
    }
    setAlertAccountId(accountId) {
        this.setFieldValue(FieldsFactory.FIELD_ACCOUNT_ID, accountId);
    }
    setUserId(userId) {
        this.setFieldValue(FieldsFactory.FIELD_USER_ID, userId);
    }
    setTradableInstrumentId(instrumentId) {
        this.setFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, instrumentId);
    }
    setRouteId(routeId) {
        this.setFieldValue(FieldsFactory.FIELD_ROUTE_ID, routeId);
    }
    setAlertType(alertType) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_TYPE, alertType);
    }
    setAlertCondition(alertCondition) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_CONDITION, alertCondition);
    }
    setAlertValue(alertValue) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_VALUE, alertValue);
    }
    setAlertImportance(alertImportance) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_IMPORTANCE, alertImportance);
    }
    setAlertDate(alertDate) {
        this.setFieldValue(FieldsFactory.FIELD_DATE, alertDate);
    }
    setAlertAfterExecute(alertAfterExecute) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_AFTER_EXECUTE, alertAfterExecute);
    }
    setAlertAction(alertAction) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_ACTION, alertAction);
    }
    setAlertNotification(alertNotification) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_NOTIFICATION, alertNotification);
    }
    setAlertText(alertText) {
        this.setFieldValue(FieldsFactory.FIELD_TEXT, alertText);
    }
    setAlertLeverage(alertLeverage) {
        this.setFieldValue(FieldsFactory.FIELD_LEVERAGE_SHORT, alertLeverage);
    }
}
